module.exports = __webpack_public_path__ + "img/block.567b4933.svg";